import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  IconFormula,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { Formula, RegularBenefitVariant } from '../../../../../../../typings'
import { ViewProps } from '../../View'
import { messages } from './messages'

type Props = ViewProps & {
  config: Formula
}

export function FormulaView(props: Props) {
  const { onEdit, onRemove, config } = props

  const handleEdit = () => onEdit(RegularBenefitVariant.Formula)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconFormula />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>{config.expression}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
